import { db } from './searchBarPersistence.db'

export async function clearRecentSearches() {
  await db.recentSearches.clear()

  return db.recentSearches.toArray()
}

export async function getRecentSearches() {
  return db.recentSearches.toArray()
}

export async function saveRecentSearches(title, link) {
  if (!title) throw new Error('Missing parameter title for saveRecentSearches')

  if (!link) throw new Error('Missing parameter link for saveRecentSearches')

  await db.recentSearches.put({ title, link })

  return db.recentSearches.toArray()
}
